import styled from 'styled-components';

import { media } from '@theme/media';
import { FONT_SIZE, typography } from '@theme/font';
import { OFFSET } from '@theme/helpers';

export const Container = styled.div`
  height: 8vh;
  display: flex;
  margin-top: ${OFFSET.S};
`;

export const Separator = styled.div`
  height: 1px;
  width: 100%;
  margin-bottom: calc(100px - ${OFFSET.S});
`;

export const InnerContainer = styled.ul`
  margin: 0 auto;
  padding: 0;
  display: flex;
  justify-content: center;
  list-style-type: none;
  gap: ${OFFSET.M};
  align-items: center;

  ${media.tablet} {
    gap: ${OFFSET.M};
  }

  ${media.desktop} {
    gap: ${OFFSET.L};
  }
`;

export const FilterOption = styled.li`
  ${typography({})};
  cursor: pointer;
  text-decoration: ${(props: { isActive: boolean }) => (props.isActive ? 'underline' : 'none')};

  &:hover {
    text-decoration: underline;
  }

  ${media.mobile} {
    ${typography({ size: FONT_SIZE.M })};
  }
`;
